module.exports = __webpack_public_path__ + "img/service_sounddesignt.9c85cf20.jpg";